module.exports = __webpack_public_path__ + "img/bg6-3.408d62f8.png";